import { render, staticRenderFns } from "./LivePrimaryInfo.vue?vue&type=template&id=191483e6&scoped=true"
import script from "./LivePrimaryInfo.vue?vue&type=script&lang=js"
export * from "./LivePrimaryInfo.vue?vue&type=script&lang=js"
import style0 from "./LivePrimaryInfo.vue?vue&type=style&index=0&id=191483e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191483e6",
  null
  
)

export default component.exports